<!-- HTML -->
<template>
  <div id="mainContainer">
    <header>
      <div id="hContent">
        <div id="intro">
          <h1 id="title">PC CHOOSER</h1>
          <h2 class="subtitle">
            Our easy-to-use online tool to help you choose the best PC based on
            your specific needs. All you have to do is fill out a form and we’ll
            pick the best options for you!
          </h2>
          <b-button id="bStart" variant="info">Get Started</b-button>
        </div>

        <div id="qDiv">
          <div id="dynamicDiv"></div>
          <div id="buttonsDiv">
            <b-button variant="danger" id="bBack" class="bottom-button"
              >Back</b-button
            >
            <b-button variant="primary" id="bNext" class="bottom-button"
              >Next</b-button
            >
          </div>
        </div>

        <div id="resDiv">
          <!-- cheapest option -->
          <b-card class="resCard">
            <h4 class="cardTitle">Cheapest Option</h4>
            <h3 id="cheapest_pc_name">Lenovo 81FB0008LM</h3>
            <img
              class="cardImg"
              id="cheapest_pc_img"
              src="https://images-na.ssl-images-amazon.com/images/I/71xhjT6JgNL._AC_SL1500_.jpg"
            />
            <h3 id="cheapest_pc_price">$596 USD</h3>
            <b-button class="amazonBtn" id="cheapest_pc_btn" variant="warning"
              >Find it on Amazon</b-button
            >
          </b-card>

          <!-- recommended option -->
          <b-card class="resCard">
            <h4 class="cardTitle">Recommended</h4>
            <h3 id="recommended_pc_name">Huawei Matebook</h3>
            <img
              class="cardImg"
              id="recommended_pc_img"
              src="https://images-na.ssl-images-amazon.com/images/I/61izFNGCSYL._AC_SL1000_.jpg"
            />
            <h3 id="recommended_pc_price">$678 USD</h3>
            <b-button
              class="amazonBtn"
              id="recommended_pc_btn"
              variant="warning"
              >Find it on Amazon</b-button
            >
          </b-card>

          <!-- specs card -->
          <b-card class="resCard">
            <h4 class="cardTitle">Your Needs</h4>
            <b-table
              id="requirementsTable"
              striped
              hover
              :items="items"
            ></b-table>
          </b-card>

          <b-button variant="danger" id="res_back_btn">Back</b-button>
        </div>
      </div>
    </header>

    <footer>
      <div id="footerContent">CHOOSE.COMPUTER</div>
    </footer>
  </div>
</template>

<script>
// imports
import firebase from "firebase";

// variables
let pc_country;

// questions data
let quests = [
  {
    id: "cpu",
    title: "Processing Power",
    q: [
      {
        txt: "For how long do you want your PC to endure? (in years)",
        options: {
          value: [1, 2, 3],
          text: ["1-3", "3-5", "5+"],
        },
        ans: 0,
      },
      {
        txt: "How fast do you need your PC to be?",
        //options: ["Low","Moderate","Fast"],
        options: {
          value: [1, 2, 3],
          text: ["Low", "Moderate", "Fast"],
        },
        ans: 0,
      },
    ],
  },
  {
    id: "ram",
    title: "Memory Capacity",
    q: [
      {
        txt: "How many programs do you have open at the same time?",
        options: {
          value: [1, 2, 3],
          text: ["1-3", "3-6", "7+"],
        },
        ans: 0,
      },
      {
        txt: "When browsing, how many tabs do you have at the same time?",
        options: {
          value: [1, 2, 2],
          text: ["1-5", "5-10", "11+"],
        },
        ans: 0,
      },
      {
        txt:
          "Do you use software to execute extensive calculations? (excel, programming, games, etc.)",
        options: {
          value: [1, 2],
          text: ["No", "Yes"],
        },
        ans: 0,
      },
    ],
  },
  {
    id: "storage",
    title: "Storage",
    q: [
      {
        txt:
          "How fast do you want your pc to initialize and your software to launch?",
        options: {
          value: [1, 2],
          text: ["Standard", "Fast"],
        },
        ans: 0,
      },
      {
        txt: "How much storage do you need?",
        options: {
          value: [120, 250, 500, 1000, -1],
          text: ["120 Gb", "250 Gb", "500 Gb", "1 Tb", "1+ Tb"],
        },
        ans: 0,
      },
    ],
  },
  {
    id: "gpu",
    title: "Graphics Power",
    q: [
      {
        txt: "Do you use 3D modelling software?",
        options: {
          value: [0, 2],
          text: ["No", "Yes"],
        },
        ans: 0,
      },
      {
        txt:
          "Do you want to play games? If so, what kind of games do you want to play?",
        options: {
          value: [0, 1, 2, 3],
          text: [
            "Not for games",
            "Old/retro games",
            "Standard games (cuphead, super meat boy, etc.)",
            "AAA games",
          ],
        },
        ans: 0,
      },
    ],
  },
  {
    id: "country",
    title: "Please select your country",
    q: [
      {
        txt: "This is only to know which currency to use.",
        options: {
          value: ["pc_usa", "pc_mex", "pc_usa"],
          text: ["United States", "Mexico", "Other"],
        },
        ans: 0,
      },
    ],
  },
];

let requirements = {
  cpu: 0,
  ram: 0,
  storage: 0,
  drive: "HDD",
  gpu: "Low",
};

let cpuConstants = {
  high: 2.6,
  mid: 2.2,
  low: 1.8,
};
let ramConstants = {
  high: 16,
  mid: 8,
  low: 4,
};

let price_tolerance = {
  usa: 100,
  mex: 2000,
};

function populateDiv(section) {
  let dynamicDiv = document.getElementById("dynamicDiv");
  let data = quests[section];

  dynamicDiv.innerHTML = "";

  // title
  let title = document.createElement("h2");
  title.innerHTML = data.title;
  dynamicDiv.appendChild(title);

  // questions
  for (let q = 0; q < data.q.length; q++) {
    // div form-group
    let fg = document.createElement("div");
    fg.classList.add("form-group");
    fg.classList.add("qSelDiv");

    // label
    let lb = document.createElement("label");
    lb.setAttribute("for", "s" + q);
    lb.classList.add("mt-4");
    lb.innerHTML = data.q[q].txt;
    fg.appendChild(lb);

    // select
    let sel = document.createElement("select");
    sel.classList.add("form-control");
    sel.setAttribute("id", data.id + q);
    for (let o = 0; o < data.q[q].options.value.length; o++) {
      let opt = document.createElement("option");
      opt.text = data.q[q].options.text[o];
      opt.value = data.q[q].options.value[o];
      sel.appendChild(opt);
    }
    fg.appendChild(sel);
    dynamicDiv.appendChild(fg);
  }
}

function toggleVisibility(e1, e2) {
  //fade out e1
  let transitionTime = 20;
  let op1 = 1;
  let timer = setInterval(function () {
    if (op1 <= 0.1) {
      clearInterval(timer);
      e1.style.visibility = "collapse";
      // fade in e2
      var op2 = 0.1;
      e2.style.visibility = "visible";
      e2.style.opacity = op2;
      var timer2 = setInterval(function () {
        if (op2 >= 1) {
          clearInterval(timer2);
        }
        e2.style.opacity = op2;
        e2.style.filter = "alpha(opacity=" + op2 * 100 + ")";
        op2 += op2 * 0.1;
      }, transitionTime);
    }
    e1.style.opacity = op1;
    e1.style.filter = "alpha(opacity=" + op1 * 100 + ")";
    op1 -= op1 * 0.1;
  }, transitionTime);
}

function toggleQuestionVisibility(section) {
  let element = document.getElementById("qDiv");
  //fade out e1
  let transitionTime = 20;
  let op1 = 1;
  let timer = setInterval(function () {
    if (op1 <= 0.1) {
      clearInterval(timer);
      populateDiv(section);
      element.style.visibility = "collapse";
      // fade in e2
      var op2 = 0.1;
      element.style.visibility = "visible";
      element.style.opacity = op2;
      var timer2 = setInterval(function () {
        if (op2 >= 1) {
          clearInterval(timer2);
        }
        element.style.opacity = op2;
        element.style.filter = "alpha(opacity=" + op2 * 100 + ")";
        op2 += op2 * 0.1;
      }, transitionTime);
    }
    element.style.opacity = op1;
    element.style.filter = "alpha(opacity=" + op1 * 100 + ")";
    op1 -= op1 * 0.1;
  }, transitionTime);
}

function captureAnswers(section) {
  let sectionName = quests[section].id;
  let questions = quests[section].q;

  // get values
  let req = 0;
  let driveTypeValue = 1;
  for (let i = 0; i < questions.length; i++) {
    let sel = document.getElementById(quests[section].id + i);
    let selValue = parseInt(sel.value);
    switch (sectionName) {
      case "cpu":
        req = selValue > req ? selValue : req;
        break;
      case "ram":
        req = selValue > req ? selValue : req;
        break;
      case "storage":
        req = i == 1 ? selValue : req;
        driveTypeValue = i == 0 ? selValue : driveTypeValue;
        break;
      case "gpu":
        req = selValue > req ? selValue : req;
        break;
      case "country":
        break;
      default:
        console.log("something went wrong");
        break;
    }
  }

  // assign to requirements JSON
  switch (sectionName) {
    case "cpu":
      switch (req) {
        case 1:
          requirements.cpu = cpuConstants.low;
          break;
        case 2:
          requirements.cpu = cpuConstants.mid;
          break;
        case 3:
          requirements.cpu = cpuConstants.high;
          break;
        default:
          console.log("Error in captureAnswers at CPU switch");
          break;
      }
      break;
    case "ram":
      switch (req) {
        case 1:
          requirements.ram = ramConstants.low;
          break;
        case 2:
          requirements.ram = ramConstants.mid;
          break;
        case 3:
          requirements.ram = ramConstants.high;
          break;
        default:
          console.log("Error in captureAnswers at RAM switch");
          break;
      }
      break;
    case "storage":
      requirements.drive = driveTypeValue == 2 ? "SSD" : "HDD";
      requirements.storage = req == -1 ? "1000+" : req;
      break;
    case "gpu":
      switch (req) {
        case 0:
          requirements.gpu = "None";
          break;
        case 1:
          requirements.gpu = "Low";
          break;
        case 2:
          requirements.gpu = "Mid";
          break;
        case 3:
          requirements.gpu = "High";
          break;
        default:
          console.log("Error in captureAnswers at GPU switch");
          break;
      }
      break;
    case "country":
      break;
    default:
      console.log("something went wrong in requirement assignation switch");
      break;
  }
}

function IsValidPc(pc) {
  if (pc.cpu >= requirements.cpu) {
    if (StrLvlToNum(pc.gpu) >= StrLvlToNum(requirements.gpu)) {
      if (pc.ram >= requirements.ram) {
        if (requirements.drive == "HDD" || pc.drive == "SSD") {
          if (pc.storage >= requirements.storage) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

function StrLvlToNum(lvl) {
  switch (lvl) {
    case "None":
      return 0;
    case "Low":
      return 1;
    case "Mid":
      return 2;
    case "High":
      return 3;
    default:
      return -1;
  }
}

function ComparePcs(bestPc, pc, price_limit) {
  if (parseFloat(pc.price) <= parseFloat(price_limit)) {
    if (pc.cpu > bestPc.cpu) return pc;
    if (StrLvlToNum(pc.gpu) > StrLvlToNum(bestPc.gpu)) return pc;
    if (pc.ram > bestPc.ram) return pc;
    if (pc.drive == "SSD" && bestPc.drive == "HDD") return pc;
    if (pc.storage > bestPc.storage) return pc;
  }
  return bestPc;
}

function AddPcToCard(pc, card_prefix) {
  document.getElementById(card_prefix + "name").innerHTML = pc.name;
  document.getElementById(card_prefix + "price").innerHTML = "$" + pc.price;
  document.getElementById(card_prefix + "btn").onclick = function () {
    window.open(pc.link);
  };
  firebase
    .storage()
    .ref(`${pc_country}/${pc.id}.jpg`)
    .getDownloadURL()
    .then(function (url) {
      document.getElementById(card_prefix + "img").src = url;
    })
    .catch(function (error) {
      alert("Error: " + error.message);
    });
}

function GetPriceTolerance() {
  switch (pc_country) {
    case "pc_mex":
      return price_tolerance.mex;
    case "pc_usa":
      return price_tolerance.usa;
    default:
      return price_tolerance.usa;
  }
}

function ProcessPcs(pcs) {
  // sort pcs by price
  pcs.sort(function (pcA, pcB) {
    return pcA.price - pcB.price;
  });

  // find recommendations
  let minPc;
  let bestPc;
  let price_tol = GetPriceTolerance(); // choose according to selected country
  let price_limit = 0;
  let minPcFound = false;
  pcs.forEach((pc) => {
    if (IsValidPc(pc)) {
      // find cheapest pc
      if (!minPcFound) {
        minPc = pc;
        bestPc = pc;
        minPcFound = true;
        price_limit = parseFloat(minPc.price) + price_tol;
      } else {
        // find best pc
        bestPc = ComparePcs(bestPc, pc, price_limit);
      }
    }
  });

  // Add pcs to cards
  AddPcToCard(bestPc, "recommended_pc_");
  AddPcToCard(minPc, "cheapest_pc_");
}

function DocToJson(doc) {
  let data = doc.data();
  let pc = {
    id: doc.id,
    cpu: data.cpu,
    drive: data.drive,
    available: data.available,
    gpu: data.gpu,
    link: data.link,
    name: data.name,
    os: data.os,
    price: data.price,
    ram: data.ram,
    storage: data.storage,
  };

  return pc;
}

function ProcessUserData(ths) {
  // Refresh requirements table
  ths.items = [];
  ths.items.push({ spec: "cpu", minimum: requirements.cpu + " Ghz" });
  ths.items.push({ spec: "ram", minimum: requirements.ram + " Gb" });
  ths.items.push({ spec: "graphics", minimum: requirements.gpu });
  ths.items.push({ spec: "drive", minimum: requirements.drive });
  ths.items.push({
    spec: "storage",
    minimum: requirements.storage + " Gb",
  });

  // Scan through DB (find first cheapest option, then best price-quality)
  let foundMinPc = false;
  let db = firebase.firestore();
  let pcs = [];
  pc_country = document.getElementById("country0").value;
  let ref = pc_country;
  db.collection(ref)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let pc = DocToJson(doc);
        pcs.push(pc);
      });

      ProcessPcs(pcs);
    })
    .catch(function (error) {
      alert(error.message);
    });
}

export default {
  name: "PcChooser",
  metaInfo: {
    title: "Find your computer",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Find a computer based on your unique needs. Just fill this form and it will search through Amazon to find the best computer for you!",
      },
    ],
  },
  mounted() {
    // init setup
    let ths = this;
    let introDiv = document.getElementById("intro");
    let qDiv = document.getElementById("qDiv");
    let bNext = document.getElementById("bNext");
    let resDiv = document.getElementById("resDiv");
    let resBackBtn = document.getElementById("res_back_btn");
    resDiv.style.visibility = "collapse";
    qDiv.style.visibility = "collapse";
    let actualSection = 0;
    let maxSections = quests.length - 1;
    populateDiv(actualSection);

    // dom
    let bStart = document.getElementById("bStart");
    bStart.onclick = function () {
      toggleVisibility(introDiv, qDiv);
    };
    bNext.onclick = function () {
      captureAnswers(actualSection);
      if (actualSection < maxSections) {
        toggleQuestionVisibility(++actualSection);
      } else {
        ProcessUserData(ths);
        toggleVisibility(qDiv, resDiv);
      }
    };
    bBack.onclick = function () {
      if (actualSection > 0) {
        toggleQuestionVisibility(--actualSection);
      } else {
        toggleVisibility(qDiv, introDiv);
      }
    };
    resBackBtn.onclick = function () {
      toggleVisibility(resDiv, qDiv);
    };
  },
  data() {
    return {
      items: [],
    };
  },
};
</script>

<style scoped>
header {
  background-image: url("../assets/commodore.jpg");
  background-size: 350%;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
}

footer {
  background-color: rgb(39, 39, 39);
  height: 10vh;
}

#footerContent {
  padding-top: 2.5vh;
  color: white;
  text-align: center;
}

#hContent {
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.493);
  padding-bottom: 6vh;
  height: 90vh;
}

#intro {
  position: absolute;
  padding-left: 10vw;
  padding-right: 10vw;
  margin-top: 20vh;
}

#title {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 800;
}

#bStart {
  margin-top: 2.5vh;
  font-size: 1.2rem;
}

#qDiv {
  font-size: 1.35rem;
  position: absolute;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 16vh;
}

#buttonsDiv {
  margin-top: 5vh;
  display: flex;
  flex-direction: row;
}

#bNext {
  margin-left: auto;
}

#resDiv {
  height: inherit;
  overflow: scroll;
}

.resCard {
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5vh;
  margin-bottom: 3vh;
  color: black;
}

.cardTitle {
  color: black;
}

.cardImg {
  margin-top: 3vh;
  margin-bottom: 1.5vh;
  width: 80vw;
}

.amazonBtn {
  font-size: 1.2rem;
}

.qSelDiv {
  padding-top: 50vw;
}

.bottom-button {
  width: fit-content;
  font-size: 1.2rem;
  padding-left: 7vw;
  padding-right: 7vw;
}

.subtitle {
  padding-top: 3vh;
  font-size: 1.5rem;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  opacity: 0.75;
}

@media screen and (min-width: 600px) {
  header {
    background-size: cover;
  }

  #hContent {
    padding-top: 2vh;
    min-height: 100vh;
  }

  #intro {
    margin-top: 24vh;
  }

  #qDiv {
    width: 100%;
    padding-top: 10vh;
  }

  #dynamicDiv {
    width: 50vw;
    margin-left: auto;
    margin-right: auto;
  }

  #buttonsDiv {
    width: 40vw;
    margin-left: auto;
    margin-right: auto;
  }

  #resDiv {
    width: fit-content;
    height: fit-content;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
  }

  #res_back_btn {
    margin-top: 2vh;
    margin-left: 4vw;
    min-width: 15vw;
    min-height: 7vh;
    font-size: 1.7rem;
  }

  .resCard {
    width: 30vw;
    margin-right: 1.2vw;
    margin-left: 1.2vw;
  }

  .cardImg {
    width: 25vw;
  }

  .bottom-button {
    padding-left: 3vw;
    padding-right: 3vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PcChooser.vue